import type { CardFaceData } from '../../global-types';

export enum CardFaceReadinessAction {
  SetFaceReadiness = 'cardFaceReadiness/setFaceReadiness',
  ResetFaceReadiness = 'cardFaceReadiness/resetFaceReadiness',
}

export type CardFaceIdentity = Pick<CardFaceData, 'faceId' | 'faceNumber' | 'type'> & { editorSessionKey: string };

export type CardFaceReadinessStatus = 'loading' | 'recovery' | 'ready' | 'fatal';

export type CardFaceReadiness = CardFaceIdentity & {
  generation: number;
  status: CardFaceReadinessStatus;
};

export type CardFaceReadinessState = {
  faceReadiness: CardFaceReadiness[];
};

export type CardFaceReadinessActions = {
  setFaceReadiness: (readiness: CardFaceReadiness) => void;
  resetFaceReadiness: () => void;
};

export type CardFaceReadinessStore = CardFaceReadinessState & CardFaceReadinessActions;
